<template>
  <v-data-table :loading="!children" :headers="headers" :search="search" :items-per-page="7" :items="children">
    <template v-slot:item.sl="{ index, item }">
      {{ index + 1 }}
    </template>
    <template v-slot:item.name="{ item }" v-if="$canRoute('create-new-user-account') === 1">
      <router-link class="text-capitalize text--ash" :to="`/registered-user-details/${item?.id}`">
       {{ `${item?.fname} ${item?.lname}` }}
      </router-link>
    </template>
    <template v-slot:item.name="{ item }" v-else>
      {{ `${item?.fname} ${item?.lname}` }}
    </template>
    <template v-slot:item.ib_code="{ item }">
      {{ item?.id }}
    </template>
    <template v-slot:item.registered_at="{ item }">
      {{ formatMySQLDate(item?.registered_at) }}
    </template>
    <template v-slot:item.total_lot="{ item }">
      {{ item?.total_lot?.toFixed(2) }}
    </template>
    <template v-slot:item.total_deposit="{ item }">
      {{ item?.total_deposit?.toFixed(2) }}
    </template>
    <template v-slot:item.total_commission="{ item }">
      {{ item?.total_commission?.toFixed(2) }}
    </template>
  </v-data-table>
</template>

<script>
import { formatMySQLDate } from '@/_helpers/formateDate';


export default {
  props: {
    children: {
      type: Array,
      default: () => []
    },
    search: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      headers: [
        { text: "Sl", align: "start", value: "sl" },
        { text: "Level", value: "level" },
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "IB Code", value: "ib_code" },
        { text: "Country", value: "country" },
        { text: "Reg Time", value: "registered_at" },
        { text: "Total Lot", value: "total_lot" },
        { text: "Invest", value: "total_deposit" },
        { text: "Commission", value: "total_commission" }
      ]
    };
  },

  computed: {
    processedItems() {
      return this.children.map((item, index) => ({
        ...item,
        SrNo: index + 1,
        registered_at: this.formatDate(item.registered_at)
      }));
    }
  },

  methods: {
    formatMySQLDate,
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString();
    }
  }
};
</script>